import {
  Role,
  SplatContact,
} from "../../amplify/backend/function/OfferExpContacts/ts/public/types";
import { SplatProspectResponse } from "../../amplify/backend/function/OfferExpUsage/ts/public/types";
import { ListOffer } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import { ROLES } from "./usageUtils";

const getPrimaryContact = (contacts: SplatContact[] | undefined) => {
  if (!contacts?.length) {
    return;
  }

  return contacts?.find((contact: SplatContact) => contact.primary);
};

const getPrimarySignerContact = (
  contacts: SplatContact[] | undefined,
  primarySignerRole: Role
) =>
  contacts?.find(
    (contact) =>
      contact.roles.includes(primarySignerRole) &&
      (primarySignerRole === ROLES.HOMEOWNER ? contact.primary : true)
  );

const findContact = (
  contacts: SplatContact[] | undefined,
  contactRole: Role
) => {
  if (contactRole === ROLES.HOMEOWNER) {
    return contacts?.find((contact: SplatContact) => contact.primary);
  }

  return contacts?.find((contact: SplatContact) =>
    contact.derivedRoles.includes(contactRole)
  );
};

const getContactsOnTitle = (contacts: SplatContact[] | undefined) => {
  return (
    contacts?.filter(
      (contact) => contact.relationToHomeowner === "Is titleholder"
    ) || []
  );
};

const getNamesOnTitle = (prospect: SplatProspectResponse | undefined) => {
  if (!prospect) return [];
  const { primaryTitle, secondaryTitle } = prospect;
  const titleNames = [];
  primaryTitle && titleNames.push(primaryTitle);
  secondaryTitle && titleNames.push(secondaryTitle);
  return titleNames;
};

const getOfferContact = (
  contacts: SplatContact[] | undefined,
  offers: ListOffer[] | undefined
) => {
  const mostRecentOffer = offers?.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
  const name = mostRecentOffer?.customerName;
  return (
    contacts?.find(({ primary }) => primary) ||
    contacts?.find(
      ({ customerFirstName, customerLastName }) =>
        `${customerFirstName} ${customerLastName}` === name
    )
  );
};

export {
  getContactsOnTitle,
  getPrimaryContact,
  getPrimarySignerContact,
  findContact,
  getNamesOnTitle,
  getOfferContact,
};
